import React from "react";
import PropTypes from "prop-types";
import { COLOR_RB_PURPLE_300 } from "@website-builder/utilities-index";
import { StyledButton } from "./style";

const Button = (props) => {
	const {
		btnType,
		children,
		color,
		type,
		onClick,
		className,
		disabled,
		darkBg,
	} = props;
	return (
		<StyledButton
			type={btnType ? btnType : "button"}
			className={className}
			color={color}
			darkBg={darkBg}
			type={type}
			disabled={disabled}
			onClick={btnType === "submit" ? () => {} : onClick}
		>
			{children}
		</StyledButton>
	);
};

Button.defaultProps = {
	onClick: () => {},
	className: "",
	type: "solid",
	color: COLOR_RB_PURPLE_300,
	children: "",
};

Button.propTypes = {
	onClick: PropTypes.func,
	className: PropTypes.string,
	type: PropTypes.oneOf(["solid", "outline"]),
	color: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default Button;
